class MultiColumnTab extends HTMLElement {
    constructor() {
      super();
      this.tabKeys = this.querySelector("#tab-keys")?.children;

      if(this.tabKeys && this.tabKeys.length > 0){
            this.onClickTab(this.tabKeys[0])
            for (const keyEl of this.tabKeys) {
                keyEl.addEventListener("click", (e) => {
                    this.onClickTab(e.target)
                })
            }
        }
    }

     onClickTab(el){
        for (const key of this.tabKeys) {
            if(key.classList.contains("active")){
                key.classList.remove('active')
            }
        }
        el.classList.add('active');
        const key = el.innerHTML.trim()
        this.changeListData(key)
    }
    
     changeListData(key){
        const sliders = this.querySelector(".slider-keys")?.children;
        for (const slider of sliders) {
            const sliderKey = slider.dataset.tabKey
            if(sliderKey !== key){
                slider.classList.add('hidden')
            }else {
                slider.classList.remove('hidden')
            }
        }
    }
  }
  
  customElements.define("multicolumn-tab", MultiColumnTab);
  


